import {
    germanDateStringToTimestamp,
    getAgeByGermanDateString,
    splitGermanDateString
} from '../../helpers/date';

const DEFAULT_MIN_AGE = 18;
const DEFAULT_MAX_AGE = 120;

export const isValidDateInput = (dateString: string) => {
    try {
        const [dd, mm, yyyy] = splitGermanDateString(dateString);

        const date = new Date(Date.UTC(yyyy, mm - 1, dd));
        return dd === date.getUTCDate() && mm - 1 === date.getUTCMonth() && yyyy === date.getUTCFullYear();
    } catch {
        return false;
    }
};

export const gteMinAge = (dateString: string, minAge = DEFAULT_MIN_AGE) => {
    try {
        const age = getAgeByGermanDateString(dateString);
        return age >= minAge;
    } catch {
        return false;
    }
};

export const lteMaxAge = (dateString: string, maxAge = DEFAULT_MAX_AGE) => {
    try {
        const age = getAgeByGermanDateString(dateString);
        return age <= maxAge;
    } catch {
        return false;
    }
};

export const isPastDate = (dateString: string) => {
    try {
        const dateTimestamp = germanDateStringToTimestamp(dateString);

        const now = new Date();
        const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());

        return dateTimestamp < today;
    } catch {
        return false;
    }
};

/*
 * switching date validation (schema: {dd}.{mm}.{yyyy}) functions
 *
 */
export const isValidSwitchingDate = (dateString: string, switchingDates: number[]) => {
    try {
        const dateTimestamp = germanDateStringToTimestamp(dateString);

        return switchingDates.includes(dateTimestamp);
    } catch (e) {
        return false;
    }
};
